import styled from "styled-components";
import { WrapperContainer } from "../../../components";
import { TableWrapper } from "../../../components/Table/styled";

export const MarketTableWrapper = styled(WrapperContainer)`
  ${TableWrapper} {
    max-height: 58vh;
  }
`;

export const MarketList = styled(WrapperContainer)`
  width: 100%;
  gap: 16px;
  flex-wrap: wrap;
`;
